import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  StackDivider,
  Text,
  useToast,
} from "@chakra-ui/react";
import { Card, CardHeader, CardBody, CardFooter } from "@chakra-ui/react";
import { createDocument, getDocument } from "../Repos/Sanity";
import { getSymbolDataAlphaVantage } from "../Repos/AlphaVantageRepository";
import { useDispatch, useSelector } from "react-redux";
import { getglobalStoreObject, setState } from "../Stores/globalStore";
import { LoadAverages } from "../Repos/StocksCalculations";
import { compareDates, formatDate } from "../Repos/Utils";
import { CloseIcon } from "@chakra-ui/icons";

function Sidebar(props) {
  // console.log("sidebar props", props);
  const toast = useToast();
  const globalStore = useSelector(getglobalStoreObject);
  const _dispatch = useDispatch();

  const [sortings, setsortings] = React.useState([
    "Alphabet",
    "Volatility",
    "Earnings date",
    "Performance",
    "OverPriced",
    "OcfYield",
  ]);
  const [sortingSelected, setsortingSelected] = React.useState(0);

  const [searchText, setsearchText] = React.useState("");

  const handleNewSymbolSearch = (_symbolName, _settings, _profile) => {
    //here we have to do all the users check
    //is he licensed
    // console.log("_profile.menuSymbols", _profile.menuSymbols);
    if (compareDates(formatDate(new Date()), _profile.expireDate)) {
      //if we are not premium
      //then
      // if (_profile.userName == "guest") {
      //   toast({
      //     title: "License invalid",
      //     description: "Create an account to allow adding to watchlist.",
      //     status: "warning",
      //     duration: 9000,
      //     isClosable: true,
      //   });
      //   return;
      // }
      //if we have less than 2 symbols
      if (_profile.menuSymbols.length >= 2) {
        //if we have more than 2 symbols
        toast({
          title: "License Required",
          description: "You can have max 2 symbols in your watchlist for free.",
          status: "warning",
          duration: 9000,
          isClosable: true,
        });
        return;
      }
    }

    getDocument(
      { _type: "symbolData", symbol: _symbolName.toUpperCase() },
      (_symbols) => {
        // console.log("_symbols.length", _symbols.length);
        //control if the symbol exists in my database
        if (_symbols.length == 0) {
          //if not exists: download it from alpha vantage
          getSymbolDataAlphaVantage(
            _symbolName,
            _settings.api_key,
            (jsonResult) => {
              //to be tested if this may work to check the api call max reached
              var objectResult = JSON.parse(jsonResult);

              // console.log("objectResult from alpha vantage", objectResult);

              if (!!objectResult["Error Message"]) {
                //if there was an error in the api call (even with incorrect symbol)
                toast({
                  title: "Symbol not found",
                  description: "The symbol you inserted is incorrect.",
                  status: "error",
                  duration: 9000,
                  isClosable: true,
                });
                return;
              }
              if (!!objectResult["Information"]) {
                //if there was an error in the api call (even with incorrect symbol)
                toast({
                  title: "Symbol not found",
                  description: "Unexpected behaviour of the search.",
                  status: "error",
                  duration: 9000,
                  isClosable: true,
                });
                return;
              }
              const newSymbol = {
                _type: "symbolData",
                symbol: _symbolName.toUpperCase(),
                dataJson: jsonResult,
                shortUpVote: 0,
                shortDownVote: 0,
              };
              createDocument(newSymbol, () => {
                // console.log("symbol succesfully created");
                //add symbol to global store
                console.log("new symbol created");
                setsearchText("");
                props.onNewSymbolCreated(newSymbol);
              });
            }
          );
        } else {
          //things to do is symbol exists
          //add it to the current user
          //load it into the globalstore
          // console.log("existing symbol found", _symbols[0]);
          setsearchText("");

          props.onNewSymbolCreated(_symbols[0]);
        }
      }
    );
  };

  React.useEffect(() => {
    props.onChangeFoundSymbolSorting(sortingSelected);

    return () => {};
  }, [sortingSelected]);

  React.useEffect(() => {
    // console.log("total paths setted ", props.paths.length);

    var pathsLoaded = props.paths.filter((_p) => _p.loaded == true);
    var pathsSelected = props.paths.filter((_p) => _p.selected == true);
    // console.log("total paths loaded ", pathsLoaded.length);
    if (
      props.paths.length > 0 &&
      props.paths.length == pathsLoaded.length &&
      pathsSelected.length == 0
    ) {
      props.onClick(props.paths[0]);
    }

    return () => {};
  }, [props.paths]);

  return (
    <Box flex={"1"} bg="gray.100" p="4" h="100%" overflowY={"auto"}>
      <Card mb={20}>
        <CardHeader>
          <Heading size="md">WatchList</Heading>
        </CardHeader>

        <CardBody>
          <Stack divider={<StackDivider />} spacing="4">
            {/* search bar for adding a new symbol */}
            <Box>
              <Flex>
                <Box flex={1}></Box>
                <Box p={2}>
                  <Button
                    border={"1px"}
                    borderRight={"4px"}
                    borderBottom={"4px"}
                    borderColor={"purple"}
                    // h="1.75rem"ù
                    size="sm"
                    onClick={() => {
                      var newSortingPosition = sortingSelected + 1;
                      if (newSortingPosition == sortings.length) {
                        newSortingPosition = 0;
                      }
                      setsortingSelected(newSortingPosition);
                    }}
                  >
                    {"COMPARE by : " + sortings[sortingSelected]}
                  </Button>
                </Box>
              </Flex>
              <InputGroup>
                <Input
                  value={searchText}
                  onChange={(_e) => setsearchText(_e.target.value)}
                  placeholder="Add to watchlist"
                  size="md"
                />
                <InputRightElement width="4.5rem">
                  <Button
                    // h="1.75rem"ù
                    size="sm"
                    onClick={() => {
                      // console.log("search symbol", searchText);
                      handleNewSymbolSearch(
                        searchText,
                        globalStore.settings,
                        globalStore.user_profile
                      );
                    }}
                  >
                    {"Search"}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </Box>

            {(props.paths ?? []).map((_p, _i) => (
              <Flex key={_p.symbol}>
                <Button
                  variant="ghost"
                  leftIcon={<CloseIcon></CloseIcon>}
                  onClick={() => {
                    props.onSymbolDelete(_p);
                  }}
                ></Button>
                <Button
                  border={"1px"}
                  borderRight={"4px"}
                  borderBottom={"4px"}
                  borderColor={
                    _p.selected ? "orange" : _p.loaded ? "green" : "gray"
                  }
                  mb="2"
                  w="full"
                  onClick={() => {
                    props.onClick(_p);
                  }}
                >
                  <Box>
                    <Text fontWeight={"bold"} fontSize={"lg"}>
                      {_p.symbol}
                    </Text>
                    {sortingSelected == 1 ? (
                      <Text color={"gray.500"}>
                        {"volatility: " + _p.volatility + "%"}
                      </Text>
                    ) : (
                      <></>
                    )}
                    {sortingSelected == 2 ? (
                      <Text color={"gray.500"}>
                        {"earnings on: " + _p.earningsDate ??
                          "not-available" + ""}
                      </Text>
                    ) : (
                      <></>
                    )}
                    {sortingSelected == 3 ? (
                      <Text color={"gray.500"}>
                        {"performance: " + _p.performance + "%"}
                      </Text>
                    ) : (
                      <></>
                    )}
                    {sortingSelected == 4 ? (
                      <Text color={"gray.500"}>
                        {"overpricing: " + _p.overpricing + "%"}
                      </Text>
                    ) : (
                      <></>
                    )}
                    {sortingSelected == 5 ? (
                      <Text color={"gray.500"}>
                        {"ocfYield: " + _p.ocfYield + "%"}
                      </Text>
                    ) : (
                      <></>
                    )}
                  </Box>
                </Button>
              </Flex>
            ))}
          </Stack>
        </CardBody>
      </Card>
    </Box>
  );
}

export default Sidebar;
